export default __webpack_public_path__ + "static/media/imgPowerPoint.2e1c53b6.png";